import React, { createContext, useContext, useState, useEffect } from 'react';

const FontSizeContext = createContext();

export const FontSizeProvider = ({ children, initialSize = 16, minSize = 12, maxSize = 100 }) => {
    const [fontSize, setFontSize] = useState(() => {
        const savedSize = localStorage.getItem('fontSize');
        return savedSize ? parseInt(savedSize) : initialSize;
    });

    const [config] = useState({
        min: minSize,
        max: maxSize,
        initial: initialSize
    });

    useEffect(() => {
        localStorage.setItem('fontSize', fontSize.toString());
    }, [fontSize]);

    const changeFontSize = (newSize) => {
        setFontSize(newSize);
    };

    return (
        <FontSizeContext.Provider value={{ fontSize, changeFontSize, config }}>
            {children}
        </FontSizeContext.Provider>
    );
};

export const useFontSize = ({ initialFontSize, minFontSize, maxFontSize } = {}) => {
    const context = useContext(FontSizeContext);
    if (!context) {
        throw new Error('useFontSize must be used within a FontSizeProvider');
    }
    return {
        ...context,
        fontSize: context.fontSize,
        config: {
            min: minFontSize || context.config.min,
            max: maxFontSize || context.config.max,
            initial: initialFontSize || context.config.initial
        }
    };
}; 